<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{titleinfo}}
    </div>
    <div class="content whd-bgwhite whd-video">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
        <el-form-item class="is-required" label="视频标题" prop="title">
          <el-input class="whd-w360" v-model="formdata.title" type="text" maxlength="40" show-word-limit></el-input>
        </el-form-item>        
        <el-form-item class="is-required" label="上传视频" prop="url">
          <el-col :span="3" style="width: 135px">
            <el-upload
              :action="uploadvideourl"
              :data="data_"
              :show-file-list="false"
              :on-success="handlevideoSuccess"
              :before-upload="beforevideoUpload"
              accept="video/mp4"
            > 
              <div class="whd-video__btn">{{formdata.url!==''?'重新上传视频':'选择本地视频'}}</div> 
            </el-upload>
          </el-col>
          <el-col :span="6">
            <div class="el-upload__tip" style="margin-top: 0">视频大小不超过100M，仅支持mp4格式</div>
          </el-col>
        </el-form-item>  
        <el-form-item>
          <video
            v-if="formdata.url!==''"
            :src="formdata.url"
            width="150"
            controls="controls"
            style="margin-top: 15px"
          >您的浏览器不支持视频播放
          </video>        
        </el-form-item>     
        <el-form-item class="is-required" label="视频封面" prop="cover">
          <el-upload 
            drag
            :class="{'on':formdata.cover !== ''}"
            :action="uploadImg"
            :data="data_"
            :on-success="handleSuccess"
            :on-error="handleError"
            :show-file-list="false"
            :before-upload="beforeUpload"
          >
            <template v-if="formdata.cover !== ''">
              <img :src="formdata.cover" alt="" width="150" style="vertical-align: middle" />
              <span class="whd-video__span" style="left: 15px;" @click.stop="previewImg">查看</span>
              <span class="whd-video__span" style="right: 15px;">替换</span>
            </template> 
            <template v-else>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">图片大小不超过5M，支持jpg、png、jpeg格式</div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item>  
          <el-button @click="goback">取消</el-button>
          <el-button v-if="pageType=='add'" type="primary" @click="btnRelease">发布</el-button>
          <el-button v-else type="primary" @click="btnSave">保存</el-button>
        </el-form-item>        
      </el-form> 
    </div>

    <el-dialog
      title="视频封面图预览"
      :visible.sync="dialogImgVisible"
      width="600px"
      >
      <img class="whd-img-auto" :src="formdata.cover" />
    </el-dialog>    
  </div>
</template>

<script>
import api from '@/api.js';
export default {
  name: "marketVideoEdit",
  data() {
    return {
      titleinfo: "",
      uploadImg: api.uploadTokenImg,
      uploadvideourl: api.uploadTokenVideo,
      dialogImgVisible: false,
      data_: {token: sessionStorage.getItem("token")},
      formdata: {
        url: "",
        title: "",
        cover: ""
      },
      rules: {
        url: [{ required: true, message: '请上传视频', trigger: 'change' }],
        title: [{ required: true, message: '请填写视频标题', trigger: 'blur' }],
        cover: [{ required: true, message: '请上传视频封面', trigger: 'change' }]
      },
      id: "",
      pageType: ""
    }
  },
  created(){
    this.id = this.$route.query.id;
    this.pageType = this.$route.query.pageType;
    if (this.pageType === 'edit') {
      this.titleinfo = "编辑视频";
      this.InitFn();
    } else {
      this.titleinfo = "添加视频";
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    handlevideoSuccess(res, file) {
      if (res.code === 0) {
        this.formdata.url = res.path;
        this.formdata.cover = res.pic;
      } else {
        this.$message.error(res.msg);
      }
      this.loadingStatus.close();
    },
    beforevideoUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 100;
      if (file.type.indexOf('video/mp4') == -1) {
        this.$message.error("请上传mp4格式");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传视频大小不能超过100MB哦!");
        return false;
      }
      this.loadingStatus = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
        customClass: 'fontColor'
      });
    },
    handleSuccess(res, file) {
      if (res.code === 0) {
        this.formdata.cover = res.path;
      } else {
        this.$message.error(res.msg);
      }
      this.loadingStatus.close();
    },
    handleError(err, file) {
      this.$message({
        type: "error",
        message: "上传失败"
      });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;
      let status = true;
      if (!isJPG) {
        this.$message.error("只能上传 JPG或者PNG 格式图片!");
        status = false;
        return false
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
        status = false;
        return false
      }
      if(status){
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      }
      return isJPG && isLt2M;
    },
    //发布
    btnRelease() {
      let that = this;
      if (!that.formdata.url || !that.formdata.cover || !that.formdata.title) {
        that.$message({
          type: "warning",
          message: "请完善信息"
        })
      } else {
        that.axios
          .post(api.companyadmin_video_diary_add, {
            url: that.formdata.url,
            cover: that.formdata.cover,
            title: that.formdata.title
          })
          .then(response => {
            if (response.data.code == 0) {
              that.$message({
                message: '添加成功!'
              });
              that.formdata.url = "";
              that.formdata.cover = "";
              that.formdata.title = "";
            } 
          })
          .catch(() => {});
      }
    },
    //保存
    btnSave() {
      let that = this;
      that.axios
        .post(api.companyadmin_video_diary_edit, {
          video_id: that.id,
          url: that.formdata.url,
          cover: that.formdata.cover,
          title: that.formdata.title
        })
        .then(response => {
          if (response.data.code == 0) {
            that.$message({
              message: '保存成功!'
            });
          } 
        })
        .catch(() => {});
    },
    InitFn() {
      this.axios
        .post(api.companyadmin_video_diary_detail, {video_id: this.id})
        .then(response => {
          if (response.data.code == 0) {
            this.formdata = response.data.info;
          } else {
          }
        })
        .catch(() => {});
    },
    previewImg() {
      this.dialogImgVisible = true;
    }  
  }
}
</script>



